exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".b-c[data-v-ebfb16a2]{color:#2675f1 !important}.common-table .o-btn[data-v-ebfb16a2]{width:1.39rem;height:.44rem;border-radius:.06rem;font-size:.18rem;background:linear-gradient(264deg, #225bfc 0%, #062567 100%);cursor:pointer;color:#fff;border:0}", ""]);

// exports
